module.exports = __webpack_public_path__ + "media/application/images/ui/tick-top-brand-214beff94c0732dc1570198e31032276.svg";